import { useFetch } from "@common/hooks/useFetch";
import { useContext } from "react";
import { NumberOfferContext } from "../../../App";
import { ICart } from "../ICart";
import { deleteOfferRoute,deleteOfferCrossSellRoute } from "@api-routes";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { keycloakUtils } from "src/itsf/keycloak/keycloakUtils";

export const useDeleteOffer = () => {
    const [deleteOfferState, { deleteCall }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const callDeleteOffer = (cartOfferId: number): Promise<ICart | undefined> => {
        return deleteCall<ICartResponse>(keycloakUtils.isAuthenticated()?deleteOfferCrossSellRoute(cartOfferId):deleteOfferRoute(cartOfferId), {
            isSecured: keycloakUtils.isAuthenticated(),
        }).then((newCartResponse) => {
            if (newCartResponse) {
                const newCart = getResponseToState(newCartResponse);

                setNumberOfferSelected(newCart.offers.length);

                return newCart;
            }

            return undefined;
        });
      
    };

    return { deleteOfferState, callDeleteOffer };
};
